import React, { useState, useEffect } from "react";
import CardHeader from "./Utils/CardHeaderComponent";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";
import EditableTitle from "./InputComponents/EditableTitle";

interface InterconnectionProps {
  errors: string[];
  dropdownValues: {
    tab: string;
    inputName: string;
    listValue: string[];
  }[];
  
  customLabelValues : {
    table : string;
    property: string;
    value: string;
    id :string;
  }[];
  data: {
    //BBIJU KPI 1
    newInterconnection: string;
    newInterconnectionText: string;
    newInterconnectionSensitive: boolean;

    feedstock: string;
    feedstockText: string;
    feedstockSensitive: boolean;

    processingManufacturing: string;
    processingManufacturingText: string;
    processingManufacturingSensitive: boolean;

    endUsers: string;
    endUsersText: string;
    endUsersSensitive: boolean;
  };

  handleDeleteInterconnection: () => void;
  handleOnChangeInterconnection: (
    e?: React.ChangeEvent<any>,
    dropDown?: {
      name: string;
      value: string[];
    }
  ) => void;
  status: number;
  
  handleUpdateEditableTitle : (id : string, value: string)=>void;
}

function Interconnection({
  errors,
  status,
  data,
  handleDeleteInterconnection,
  handleOnChangeInterconnection,
  dropdownValues,
  customLabelValues,
  handleUpdateEditableTitle
}: InterconnectionProps) {
  const [isHidden, setIsHidden] = useState(true);
  const toggleVisibility = () => {
    setIsHidden((prevState) => !prevState);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };
  const confirmDelete = () => {
    setIsModalOpen(false);
    handleDeleteInterconnection();
  };
  const cancelDelete = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="feedstock-container">
      <CardHeader
        isHidden={isHidden}
        toggleVisibility={toggleVisibility}
        cardName="Interconnection"
        handleDelete={status == 1 ? handleDeleteClick : null}
        notValid={errors.length > 0}
      />

      <div className={isHidden ? "hidden-content" : "visible-content"}>
        <div className="form-container">
          <div className="error-container">
            {errors.map((error, index) => (
              <div
                className="error-text"
                key={index}
                style={{ marginBottom: "10px" }}
              >
                {error}
              </div>
            ))}
          </div>
          <div className="question-group-input-first">
            <div className="question-text">
              BBI JU KPI 1  🛈 <br />

              
              <EditableTitle 
                            customLabelValue={customLabelValues.find(item => item.property == "BBI1")}
                            handleUpdateEditableTitle={handleUpdateEditableTitle}
                            />
            </div>
            <div className="row">
              <div className="col-12">
                <DropdownStringMandatory
                  listInputs={["-", "Yes", "No"]}
                  label={""}
                  inputName={"newInterconnection"}
                  value={data.newInterconnection}
                  handleOnChange={handleOnChangeInterconnection}
                  invalidValues={["", "-"]}
                />
              </div>
              <div className="col-12">
                <TextConfidential
                  label={"Please explain the interconnection"}
                  textValid={data.newInterconnectionText.length > 4}
                  textValue={data.newInterconnectionText}
                  textName={"newInterconnectionText"}
                  onChange={handleOnChangeInterconnection}
                  isConfidential={data.newInterconnectionSensitive}
                  confidentialInputName={"newInterconnectionSensitive"}
                  display={data.newInterconnection != "Yes"}
                />
              </div>
            </div>

            <div
              className={
                data.newInterconnection == "Yes"
                  ? "visible-content"
                  : "hidden-content"
              }
            >
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <DropdownStringMandatory
                    listInputs={
                      dropdownValues.filter(
                        (item) => item.inputName == "feedstock"
                      )[0].listValue
                    }
                    label={"Feedstock"}
                    inputName={"feedstock"}
                    value={data.feedstock}
                    handleOnChange={handleOnChangeInterconnection}
                    invalidValues={["", "-"]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <TextConfidential
                    label={"Please explain"}
                    textValid={
                      data.feedstockText.length > 4 ||
                      !(data.feedstock == "Other")
                    }
                    textValue={data.feedstockText}
                    textName={"feedstockText"}
                    onChange={handleOnChangeInterconnection}
                    isConfidential={data.feedstockSensitive}
                    confidentialInputName={"feedstockSensitive"}
                    display={
                      data.feedstock == "N/A" ||
                      data.feedstock == "" ||
                      data.feedstock == "-"
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <DropdownStringMandatory
                    listInputs={
                      dropdownValues.filter(
                        (item) => item.inputName == "processingManufacturing"
                      )[0].listValue
                    }
                    label={"Processing & manufacturing "}
                    inputName={"processingManufacturing"}
                    value={data.processingManufacturing}
                    handleOnChange={handleOnChangeInterconnection}
                    invalidValues={["", "-"]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <TextConfidential
                    label={"Please explain"}
                    textValid={
                      data.processingManufacturingText.length > 4 ||
                      !(data.processingManufacturing == "Other")
                    }
                    textValue={data.processingManufacturingText}
                    textName={"processingManufacturingText"}
                    onChange={handleOnChangeInterconnection}
                    isConfidential={data.processingManufacturingSensitive}
                    confidentialInputName={"processingManufacturingSensitive"}
                    display={
                      data.processingManufacturing == "N/A" ||
                      data.processingManufacturing == "" ||
                      data.processingManufacturing == "-"
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <DropdownStringMandatory
                    listInputs={
                      dropdownValues.filter(
                        (item) => item.inputName == "endUsers"
                      )[0].listValue
                    }
                    label={"End users"}
                    inputName={"endUsers"}
                    value={data.endUsers}
                    handleOnChange={handleOnChangeInterconnection}
                    invalidValues={["", "-"]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <TextConfidential
                    label={"Please explain"}
                    textValid={
                      data.endUsersText.length > 4 ||
                      !(data.endUsers == "Other")
                    }
                    textValue={data.endUsersText}
                    textName={"endUsersText"}
                    onChange={handleOnChangeInterconnection}
                    isConfidential={data.endUsersSensitive}
                    confidentialInputName={"endUsersSensitive"}
                    display={
                      data.endUsers == "N/A" ||
                      data.endUsers == "" ||
                      data.endUsers == "-"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onRequestClose={cancelDelete}
        onConfirm={confirmDelete}
        title="
        Confirm deletion"
        message="Are you sure you want to delete this component ?"
      />
    </div>
  );
}

export default Interconnection;
